import React from 'react';
import GatsbyLink from '../src/components/GatsbyLink';
import './Logo.scss';

export const Logo = props => {
  return (
    <GatsbyLink to="/" className="logo"></GatsbyLink>
  );
}
